import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  headerRoot: {
    width: '80%',
  },
  columnHeaderTitle: {
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: '#617080',
  },
  columnHeaderFilter: {
    lineHeight: '50px',
    marginTop: '10px',
  },
  DataGrid: {
    '& .MuiDataGrid-main': {
      minHeight: 'calc(100vh - 16rem)',
    },
  },
}));
